/**
 * Tour steps — Compliance domain
 * Cubre: vulnerabilities, compliance-drift, dlp, data-leaks
 */

import {
  Warning as AlertTriangle,
  ListChecks,
  ShieldCheck,
  Eye
} from '@phosphor-icons/react';

// ============ VULNERABILITIES (solo full) ============
const vulnerabilitiesProspect = {
  id: 'vulnerabilities',
  title: 'Tus vulnerabilidades, priorizadas',
  description: 'Todas las debilidades detectadas ordenadas por gravedad. Vektor te dice cuáles arreglar primero según el riesgo real para tu negocio.',
  icon: AlertTriangle,
  position: 'right',
  highlight: '[data-testid="nav-vulnerabilities"]',
  fallbackSelector: '[href="/vulnerabilities"]',
  mode: 'prospect',
  length: 'full',
  domain: 'compliance',
  videoFallback: null
};

const vulnerabilitiesOnboarding = {
  id: 'vulnerabilities',
  title: 'Vulnerability Management',
  description: 'Vulns por host con CVE, CVSS, severidad y recomendación de remediación. Mapa visual con enrich fullData, fitView reset y empty state. Cross-link con alertas correlacionadas.',
  icon: AlertTriangle,
  position: 'right',
  highlight: '[data-testid="nav-vulnerabilities"]',
  fallbackSelector: '[href="/vulnerabilities"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'compliance',
  videoFallback: null
};

// ============ COMPLIANCE DRIFT (solo full) ============
const complianceDriftProspect = {
  id: 'compliance-drift',
  title: 'Cumple compliance sin esfuerzo extra',
  description: 'Vektor monitoriza si tu configuración se va alejando de lo que pide la norma (ISO 27001, NIS2, ENS) y te avisa antes de la auditoría, no después.',
  icon: ListChecks,
  position: 'right',
  highlight: '[data-testid="nav-compliance-drift"]',
  fallbackSelector: '[href="/compliance-drift"]',
  mode: 'prospect',
  length: 'full',
  domain: 'compliance',
  videoFallback: null
};

const complianceDriftOnboarding = {
  id: 'compliance-drift',
  title: 'Compliance Drift',
  description: 'Detecta desviaciones frente a baselines de configuración (CIS, ISO 27001, ENS, NIS2). Evidencia continua del cumplimiento con timestamp por control para auditores.',
  icon: ListChecks,
  position: 'right',
  highlight: '[data-testid="nav-compliance-drift"]',
  fallbackSelector: '[href="/compliance-drift"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'compliance',
  videoFallback: null
};

// ============ DLP (solo full) ============
const dlpProspect = {
  id: 'dlp',
  title: 'Evita fugas de información sensible',
  description: 'Detecta cuándo alguien intenta sacar datos confidenciales por correo, USB o servicios en la nube. Política sencilla, acción inmediata.',
  icon: ShieldCheck,
  position: 'right',
  highlight: '[data-testid="nav-dlp"]',
  fallbackSelector: '[href="/dlp"]',
  mode: 'prospect',
  length: 'full',
  domain: 'compliance',
  videoFallback: null
};

const dlpOnboarding = {
  id: 'dlp',
  title: 'DLP (Data Loss Prevention)',
  description: 'Tabla dlp_alerts con endpoints /api/dlp/alerts y /api/dlp/stats. Detección de exfiltración por canal, agregaciones JSONB y políticas configurables. UI consume endpoints reales (no mocks).',
  icon: ShieldCheck,
  position: 'right',
  highlight: '[data-testid="nav-dlp"]',
  fallbackSelector: '[href="/dlp"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'compliance',
  videoFallback: null
};

// ============ DATA LEAKS (solo full) ============
const dataLeaksProspect = {
  id: 'data-leaks',
  title: 'Vigila si tus datos están en la dark web',
  description: 'Te avisamos si credenciales o datos de tu empresa aparecen en filtraciones públicas. Te enteras antes que los atacantes los usen.',
  icon: Eye,
  position: 'right',
  highlight: '[data-testid="nav-data-leaks"]',
  fallbackSelector: '[href="/data-leaks"]',
  mode: 'prospect',
  length: 'full',
  domain: 'compliance',
  videoFallback: null
};

const dataLeaksOnboarding = {
  id: 'data-leaks',
  title: 'Data Leaks',
  description: 'Monitorización de filtraciones (breaches públicos, paste sites, dark web feeds) cruzando dominios y correos del tenant. Módulo separado de DLP, ingest dedicado.',
  icon: Eye,
  position: 'right',
  highlight: '[data-testid="nav-data-leaks"]',
  fallbackSelector: '[href="/data-leaks"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'compliance',
  videoFallback: null
};

export const domainSteps = {
  prospect: {
    quick: [],
    full: [vulnerabilitiesProspect, complianceDriftProspect, dlpProspect, dataLeaksProspect]
  },
  onboarding: {
    quick: [],
    full: [vulnerabilitiesOnboarding, complianceDriftOnboarding, dlpOnboarding, dataLeaksOnboarding]
  }
};
